<script setup lang="ts">
import { alphabetToPref } from "~/utils/sekou/area";

let [, city, off] = useRoute().params?.city.toString()?.split("_");

if (!city) city = "";
if (!off) off = "0";

const props = withDefaults(defineProps<{ pref: string }>(), {
  pref: () => "",
});

const prefKanji = alphabetToPref(props.pref);

if (!props.pref || !prefKanji) {
  throw createError("404");
}

const config = useRuntimeConfig();

useHead({
  link: [
    {
      rel: "canonical",
      href: encodeURI(
        `${config.public.siteUrl}/sekou/` +
          props.pref +
          (city ? "_" + city : "") +
          (off ? "?off=" + off : ""),
      ),
    },
  ],
});

useScrollTop(true);
</script>

<template>
  <SekouWrapper>
    <div class="wrapper">
      <TextPageTitle class="hidden sm:block">施工例</TextPageTitle>
      <div class="flex flex-col pc:flex-row">
        <SekouMenu class="pc:w-1/4" />
        <SekouAreaListWrapper
          :pref="pref"
          :city="city"
          :off="off"
          class="pc:w-3/4"
        />
      </div>
    </div>
  </SekouWrapper>
</template>
